import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ROLL_CALL_API_BASE_URL } from "../../feature-module/Pereco/RollCall/RollCallConfig/RollCallConfig";
// import { SidebarData1 } from "../../core/json/sidebar_dataone";

const HorizontalSidebar = () => {
  const navigate = useNavigate();

  const [SidebarData, setSidebarData] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [filteredSidebar, setFilteredSidebar] = useState([]);

  const filterByModule = (moduleId) => {
    const filtered = SidebarData.filter((menu) => menu.ModuleId === moduleId);
    setFilteredSidebar(filtered);
  };

  useEffect(() => {
    const savedModule = sessionStorage.getItem("selectedModuleId");
    if (savedModule) {
      filterByModule(Number(savedModule));
    }

    const handleModuleChange = (event) => {
      filterByModule(event.detail);
    };

    window.addEventListener("moduleChange", handleModuleChange);

    return () => {
      window.removeEventListener("moduleChange", handleModuleChange);
    };
  }, [SidebarData]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const userSessionData = sessionStorage.getItem("userData");
    const userData = JSON.parse(userSessionData);

    if (token && userData) {
      setTokenData(token);
      setUserId(userData?.UserId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (userId == null) {
      return;
    }
    fetch(`${ROLL_CALL_API_BASE_URL}portal/access/getmenu?UserId=${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenData}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch menu");
        }
        return response.json();
      })
      .then((data) => {
        setSidebarData(data.ResultData);
      })
      .catch((error) => {
        console.error("Error fetching menu:", error);
      });
  }, [userId]);

  const [opendSubMenu, setOpendSubMenu] = useState([null, null]);
  const sidebarRef = useRef(null);
  const location = useLocation();
  // const currentPath = location.pathname.split("/")[1];

  const showMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[0] === title ? [null, null] : [title, null],
    );
  };

  const showSubMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[1] === title ? [prevState[0], null] : [prevState[0], title],
    );
  };

  // const handleClickOutside = (event) => {
  //   if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
  //     setOpendSubMenu([null, null]);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setOpendSubMenu([null, null]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  // const filteredMenu = Object.keys(SidebarData).find((key) =>
  //   location.pathname.startsWith(`/${key}`)
  // )
  //   ? SidebarData[currentPath]
  //   : [];

  const isActiveMainMenu = (mainMenus) => {
    const currentPath = location.pathname || "";

    return (
      (mainMenus?.route &&
        currentPath.split("/")[1] === mainMenus?.route.split("/")[1]) ||
      mainMenus?.subRoutes?.some(
        (subMenu) =>
          subMenu.route &&
          currentPath.split("/")[1] === subMenu.route.split("/")[1],
      )
    );
  };

  const isActiveSubMenu = (mainMenus) => {
    const currentPath = location.pathname || "";

    return (
      (mainMenus?.route &&
        currentPath.split("/")[1] === mainMenus?.route.split("/")[1]) ||
      mainMenus?.subRoutes?.some(
        (subMenu) =>
          subMenu.route &&
          currentPath.split("/")[1] === subMenu.route.split("/")[1],
      )
    );
  };

  useEffect(() => {
    setOpendSubMenu([null, null]);
  }, [location.pathname]);
  return (
    <div
      className="sidebar sidebar-horizontal"
      id="horizontal-menu"
      ref={sidebarRef}
    >
      <div className="sidebar-menu" id="sidebar-menu-3">
        <div className="main-menu">
          <ul className="nav">
            {filteredSidebar?.map((mainTittle, mainIndex) => (
              <li
                className="submenu"
                key={mainIndex}
                onMouseLeave={() => setOpendSubMenu([null, null])}
              >
                <NavLink
                  to={mainTittle.link}
                  className={`${opendSubMenu[0] === mainTittle?.label ||
                      isActiveMainMenu(mainTittle)
                      ? "active"
                      : ""
                    }`}
                  onClick={(e) => {
                    if (mainTittle?.submenuItems?.length > 0) {
                      e.preventDefault();
                      showMenu(mainTittle?.label);
                    } else {
                      setOpendSubMenu([null, null]);
                    }
                  }}
                >
                  <i className={`ti ti-${mainTittle?.icon} me-2`}></i>
                  <span>{mainTittle?.label}</span>
                  {mainTittle?.submenuItems?.length > 0 ? (
                    <span className="menu-arrow"></span>
                  ) : (
                    ""
                  )}
                </NavLink>
                {mainTittle?.submenuItems?.length > 0 && (
                  <ul
                    className={`submenus-two ${opendSubMenu[0] === mainTittle?.label
                        ? "d-block"
                        : "d-none"
                      } border border-1 shadow rounded-bottom`}
                  >
                    {mainTittle?.submenuItems?.map((mainMenus, menuIndex) => (
                      <React.Fragment key={menuIndex}>
                        {mainMenus?.submenuItems?.length === 0 && (
                          <li>
                            <NavLink
                              to={mainMenus?.link}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <span>{mainMenus?.label}</span>
                            </NavLink>
                          </li>
                        )}

                        {mainMenus?.submenuItems?.length > 0 && (
                          <li className="submenu">
                            <a
                              className={`${isActiveSubMenu(mainMenus) ? "active" : ""
                                }`}
                              onClick={() => {
                                showSubMenu(mainMenus?.label);
                              }}
                            >
                              <span>{mainMenus?.label}</span>
                              <span className="menu-arrow"></span>
                            </a>

                            <ul
                              className={`submenus-two ${opendSubMenu[1] === mainMenus?.label
                                  ? "d-block"
                                  : "d-none"
                                } border border-1 shadow rounded-bottom`}
                            >
                              {mainMenus?.submenuItems?.map(
                                (submenuItems, subIndex) => (
                                  <li key={subIndex}>
                                    <NavLink
                                      to={submenuItems.link}
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                      onClick={() =>
                                        setOpendSubMenu([null, null])
                                      }
                                    >
                                      {submenuItems.label}
                                    </NavLink>
                                  </li>
                                ),
                              )}
                            </ul>
                          </li>
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HorizontalSidebar;
